<template>
  <main>
    <section class="head">
      <div class="head__header">
        <NotificationBanner :message="$t('beta.finish_notification')" />
        <div class="main__container">
          <TheNavbar class="spacing__pt_3" />
          <TheHeader class="the_header" />
        </div>
      </div>

      <div class="head__video">
        <TheVideo class="main__container" />
      </div>
    </section>

    <section class="body">
      <FeaturesList id="features" />
      <div class="body__contact">
        <Contact id="contact" class="main__container" />
      </div>
    </section>
    <TheFooter />
  </main>
</template>

<script>
import TheNavbar from '../components/TheNavbar'
import TheHeader from '../components/TheHeader'
import TheVideo from '../components/TheVideo'
import FeaturesList from '../components/FeaturesList'
import TheFooter from '../components/TheFooter'
import Contact from '../components/Contact'
import NotificationBanner from '../components/NotificationBanner'

export default {
  components: {
    TheNavbar,
    TheHeader,
    TheVideo,
    FeaturesList,
    TheFooter,
    Contact,
    NotificationBanner,
  },
}
</script>

<style lang="scss" scoped>
.head {
  background: linear-gradient(90deg, #2a7dd6 0%, #5a7dd6 100%);
  padding-bottom: 90px;
  &__header {
    width: 100%;
    background-color: white;
    border-radius: 0 0 50px 50px;
    padding-bottom: 168px;
  }

  &__video {
    width: 100%;
    margin-top: -88px;
  }
}

.the_header {
  padding-top: 104px;
}

.body {
  background: #f0f7fa;
  padding-top: 104px;
  width: 100%;

  &__contact {
    background: linear-gradient(90deg, #5623e2 0%, #6623e2 100%);
    border-radius: 50px 50px 0px 0px;
    padding: 56px 0 104px 0;
    margin-top: 104px;
  }
}

@media only screen and (max-width: 768px) {
  .the_header {
    padding-top: 72px;
  }

  .head {
    padding-bottom: 0;
    &__video {
      margin-top: -125px;
    }
  }

  .body {
    padding-top: 32px;

    &__contact {
      padding: 32px 0;
      margin-top: 56px;
    }
  }
}
</style>
